import {DataScienceEventNames} from './dateScienceEvents';
import {DevEventNames} from './devEvents';

export type EventConfig = {
  /* controls whether the event is sent */
  isEnabled?: boolean;
  /* controls how often the event is sent (0.0 - 1.0) */
  sampleRate?: number;
  /* logs the event data to the console */
  shouldLogToConsole?: boolean;
};

type TrackCall = (eventName: string, eventData: any) => void;

export const makeTrackEvent = <EventData>(
  eventName: DevEventNames | DataScienceEventNames,
  config: Partial<EventConfig> = {},
  random: number = Math.random(),
  track: TrackCall | undefined = window?.analytics?.track
) => {
  const {isEnabled = true, sampleRate = 1, shouldLogToConsole = false} = config;

  const shouldTrack = isEnabled && random <= sampleRate;

  return (eventData: EventData) => {
    if (shouldLogToConsole) {
      console.log(`[${eventName}]`, eventData);
    }

    if (shouldTrack) {
      // enum values aren't strict type overlaps with strings,
      // so this loosens it for the track events
      track?.(eventName as unknown as string, eventData);
    }
  };
};
